import React from 'react';
import { connect } from 'react-redux';
import Loader from 'components/Loader/Loader';
import ChatPage from 'components/Chat/ChatPage';
import { ChatProvider } from 'contexts/ChatContext';
import { AppState } from 'reducers/reducers';
import { selectedSpotInfo } from 'selectors';

type ChatContainerProps = ReturnType<typeof mapStateToProps>;

const ChatContainer = ({ spot, loadingSpots }: ChatContainerProps): JSX.Element => {
    if (!spot || loadingSpots) return <Loader />;

    return (
        <ChatProvider spotUuid={spot.uuid}>
            <ChatPage />
        </ChatProvider>
    );
};

function mapStateToProps(state: AppState) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        spot: selectedSpotInfo(state)!,
        loadingSpots: state.spots.orgSpotsLoading,
    };
}

export default connect(mapStateToProps)(ChatContainer);
